import { render, staticRenderFns } from "./SearchMessageItem.vue?vue&type=template&id=d060e5bc&scoped=true"
import script from "./SearchMessageItem.vue?vue&type=script&lang=js"
export * from "./SearchMessageItem.vue?vue&type=script&lang=js"
import style0 from "./SearchMessageItem.vue?vue&type=style&index=0&id=d060e5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d060e5bc",
  null
  
)

export default component.exports